export const filters = [
  {
    id: 1,
    name: "Molecule",
    subFilters: ["ATC class", "Dosage form", "Route of Administration"],
  },
  {
    id: 2,
    name: "Markets of Interest  ",
    // subFilters: ["Asia", "Europe", "North America", "Rest of the World"],
    subFilters: [
      "US",
      "Canada",
      "EU",
      "UK",
      "Australia",
      "LatAm",
      "MENA",
      "Africa",
      "South East Asia",
      "South Asia",
      "Russia CIS",
      "Rest of the World",
    ],
  },
  { id: 3, name: "Constraint Date After", subFilters: ["US"] },
  {
    id: 4,
    name: "Manufacturing Facility Location",
    subFilters: ["Asia", "Europe", "North America", "Rest of the World"],
  },
  {
    id: 5,
    name: "Dossier readiness ",
    // subFilters: ["Ready -US", "Ready - EU", "Early development", "Late stage"],
    subFilters: [
      "Ready : US",
      "Ready : EU",
      "Ready : Other Reg Markets",
      "Ready : Non-Reg Markets",
      "Pilot BE Complete/ Late stage development",
      "Early development",
    ],
  },
  { id: 6, name: "Curated  ", subFilters: ["Curated dossiers"] },
  {
    id: 8,
    name: "Supply ",
    subFilters: ["With supply", "Tech transfer"],
  },
];

export const searchResult = [
  {
    title: "Dexlansoprazole",
    code: " 10115",
    locations: "US, Global",
    dosStatus: "Ready, US BE available",
    curated: "Yes",
    mfg: " All regulated markets",
    com: "IND",
    usConDate: "Mar 2027 ",
    supply: "Tech Transfer Only",
    type: "Exclusivity by market",
    descp:
      "An established company based in India, is looking to out-license the dossier along with tech transfer rights. The buyer would need to submit the ANDA in his name. The seller is willing to support tech transfer  and commercial supplies will be from the new site. No limited period supply option with the seller.",
    resCapsules: "30/60mg",
    offDay: "5",
    type: "Exclusivity by market",
  },
  {
    title: "Dexlansoprazole",
    code: " 10115",
    locations: "US, ROW",
    dosStatus: "Late stage, EU BE available",
    curated: "Yes",
    mfg: " All regulated markets",
    com: "EU",
    usConDate: "Mar 2027 ",
    supply: "Tech Transfer Only",
    type: "Exclusivity by market",
    descp:
      "An emerging company based in EU, is looking to out-license the dossier and will support commercial supplies through own manufacturing plant. The product is under development and the seller has successfully completed EU BE study. While this BE study will not be made available, it certainly serves as proof of concept of readiness of the dossier. The buyer will need to invest in BE study for markets of interest.",
    resCapsules: "30/60mg",
    offDay: "5",
    type: "Exclusivity by market",
  },
  {
    title: "Dexlansoprazole",
    code: " 10115",
    locations: "US, Global",
    dosStatus: "Ready, US BE available",
    curated: "Yes",
    mfg: " All regulated markets",
    com: "IND",
    usConDate: "Mar 2027 ",
    supply: "Tech Transfer Only",
    type: "Exclusivity by market",
    descp:
      "An established company based in India, is looking to out-license the dossier along with tech transfer rights. The buyer would need to submit the ANDA in his name. The seller is willing to support tech transfer  and commercial supplies will be from the new site. No limited period supply option with the seller.",
    resCapsules: "30/60mg",
    offDay: "5",
    type: "Exclusivity by market",
  },
];

export const about = [
  {
    title: "About the molecule ",
    descp:
      "Dexlansoprazole is a proton pump inhibitor (PPI) that reduces stomach acid. It is available as delayed-release capsules, both brand and generic, in the US. On October 17, 2017, Dexilant Solutab® (disintegrating tablets) was withdrawn from the US market. Dexlansoprazole treats acid-related conditions such as erosive esophagitis and gastroesophageal reflux disease (GERD). It is also used for Symptomatic Non-Erosive GERD and is indicated for patients aged 12 and older.",
  },
  {
    title: "About the molecule ",
    descp:
      "Dexlansoprazole is a proton pump inhibitor (PPI) that reduces stomach acid. It is available as delayed-release capsules, both brand and generic, in the US. On October 17, 2017, Dexilant Solutab® (disintegrating tablets) was withdrawn from the US market. Dexlansoprazole treats acid-related conditions such as erosive esophagitis and gastroesophageal reflux disease (GERD). It is also used for Symptomatic Non-Erosive GERD and is indicated for patients aged 12 and older.",
  },
  {
    title: "About the molecule ",
    descp:
      "Dexlansoprazole is a proton pump inhibitor (PPI) that reduces stomach acid. It is available as delayed-release capsules, both brand and generic, in the US. On October 17, 2017, Dexilant Solutab® (disintegrating tablets) was withdrawn from the US market. Dexlansoprazole treats acid-related conditions such as erosive esophagitis and gastroesophageal reflux disease (GERD). It is also used for Symptomatic Non-Erosive GERD and is indicated for patients aged 12 and older.",
  },
];

// export const list = [
//   { value: "1", label: "Antiretrovirals" },
//   { value: "2", label: "HCV's" },
//   { value: "3", label: "Immunosuppressants" },
//   { value: "4", label: "Pain and anti-inflammatory range" },
//   { value: "5", label: "Anti-infectives" },
//   { value: "6", label: "Antihypertensives" },
//   { value: "7", label: "Antidiabetics" },
//   { value: "8", label: "Vit D analogues" },
//   { value: "9", label: "Antipsychotics" },
//   { value: "10", label: "Anti-hyperlipidaemic" },
//   { value: "11", label: "Anti malarial" },
//   { value: "12", label: "Gastro" },
//   { value: "13", label: "Anthelmintics" },
//   { value: "14", label: "Steroids" },
//   { value: "15", label: "PPI's" },
//   { value: "16", label: "Osmotic laxatives" },
//   { value: "17", label: "Alzheimer's" },
//   { value: "18", label: "COPD" },
//   { value: "19", label: "Antidepressants" },
//   { value: "20", label: "Ulcerative colitis" },
//   { value: "21", label: "Gout" },
//   { value: "22", label: "Hyperthyroidism" },
//   { value: "23", label: "Antifungal" },
//   { value: "24", label: "Antiepileptics" },
//   { value: "25", label: "Antihistamine" },
//   { value: "26", label: "Hyperkalaemia" },
//   { value: "27", label: "Immunomodulators" },
//   { value: "28", label: "Potent compounds (non Onco)" },
// ];
export const list = [
  { value: "1", label: "Alzheimer's Disease" },
  { value: "2", label: "Anthelmintics" },
  { value: "3", label: "Anti-infectives" },
  { value: "4", label: "Antidepressants" },
  { value: "5", label: "Antidiabetics" },
  { value: "6", label: "Antiepileptics" },
  { value: "7", label: "Antifungals" },
  { value: "8", label: "Antihistamines" },
  { value: "9", label: "Antihyperlipidemics" },
  { value: "10", label: "Antihypertensives" },
  { value: "11", label: "Antimalarials" },
  { value: "12", label: "Antiparkinsonian agents" },
  { value: "13", label: "Antipsychotics" },
  { value: "14", label: "Central Nervous System (CNS)" },
  { value: "15", label: "Chronic Obstructive Pulmonary Disease (COPD)" },
  { value: "16", label: "Gout Treatments" },
  { value: "17", label: "Hepatitis C Treatments" },
  { value: "18", label: "Hyperkalemia Treatments" },
  { value: "19", label: "Thyroid agents" },
  { value: "20", label: "Immunomodulators" },
  { value: "21", label: "Immunosuppressants" },
  { value: "22", label: "Irritable Bowel Syndrome (IBS) Treatments" },
  { value: "23", label: "Nonsteroidal Anti-inflammatory Drugs (NSAIDs)" },
  { value: "24", label: "Oncology (Cancer Treatments)" },
  { value: "25", label: "Osmotic Laxatives" },
  { value: "26", label: "Proton Pump Inhibitors (PPIs)" },
  { value: "27", label: "Muscle relaxants" },
  { value: "28", label: "Sleep disorders" },
  { value: "29", label: "Ulcerative Colitis Treatments" },
  { value: "30", label: "Vitamin D Analogues" },
  { value: "31", label: "Analgesics" },
  { value: "32", label: "Gastrointestinal" },
  { value: "33", label: "Antiemetic" },
  { value: "34", label: "Endocrinology" },
  { value: "35", label: "Osteoporosis agents" },
  { value: "36", label: "Antirheumatic" },
  { value: "37", label: "Acne treatments" },
  { value: "38", label: "Immunotherapies" },
  { value: "39", label: "Anticoagulants" },
  { value: "40", label: "Thrombolytics" },
  { value: "41", label: "Antidiarrheals" },
  { value: "42", label: "Laxatives" },
  { value: "43", label: "Antiemetics" },
  { value: "44", label: "Bronchodilators" },
  { value: "45", label: "Corticosteroids" },
  { value: "46", label: "Decongestants" },
  { value: "47", label: "Hormone replacement therapy" },
  { value: "48", label: "Antiparasitics" },
  { value: "49", label: "Antivirals" },
  { value: "50", label: "Antibiotics" },
  { value: "51", label: "Anesthetics" },
  { value: "52", label: "Anxiolytics" },
  { value: "53", label: "Stimulants" },
  { value: "54", label: "Antianginals" },
  { value: "55", label: "Diuretics" },
  { value: "56", label: "Antacids" },
  { value: "57", label: "Topical steroids" },
  { value: "58", label: "Antipyretic" },
  { value: "59", label: "Anticonvulsants" },
  { value: "60", label: "Vitamin B Analogues" },
  { value: "61", label: "Vasodialator" },
  { value: "62", label: "Antiarrhythmics" },
  { value: "63", label: "Cardiovascular Agent" },
  { value: "64", label: "Erectile dysfunction" },
];

export const list2 = [
  { value: "1", label: "Tablets" },
  { value: "2", label: "Capsules" },
  { value: "3", label: "Injectable" },
  { value: "4", label: "Oral solutions/drops" },
  { value: "5", label: "Powders/ Granules" },
  { value: "6", label: "Soft gel capsules" },
  { value: "7", label: "Cream" },
  { value: "8", label: "Lotion" },
  { value: "9", label: "Ointment" },
  { value: "10", label: "Nasal Sprays" },
  { value: "11", label: "Oral suspensions" },
  { value: "12", label: "Capsules, modified release" },
  { value: "13", label: "Tablets, modified release" },
  { value: "14", label: "Dispersible tablets" },
  { value: "15", label: "Dispersible tablets, modified release" },
  { value: "16", label: "Liquid in hard capsules" },
  { value: "17", label: "Oral dispersible films" },
  { value: "18", label: "Powders/ Granules, modified release" },
  { value: "19", label: "Soft gel capsules, modified release" },
  { value: "20", label: "Sublingual tabs" },
  { value: "21", label: "Sublingual tabs, modified release" },
  { value: "22", label: "Topical gel" },
  { value: "23", label: "Inhalation liquids" },
  { value: "24", label: "Injectable, Long acting" },
  { value: "25", label: "Suppositories" },
  { value: "26", label: "Opthalmic liquids" },
  { value: "27", label: "Rings" },
  { value: "28", label: "Transdermal patches" },
  { value: "29", label: "Tablet, chewable" },
];

// export const list3 = [
//   { value: "1", label: "Oral" },
//   { value: "2", label: "Sublingual" },
//   { value: "3", label: "Buccal" },
//   { value: "4", label: "Rectal" },
//   { value: "5", label: "Topical" },
//   { value: "6", label: "Otic" },
//   { value: "7", label: "Transdermal" },
//   { value: "8", label: "Inhalation" },
//   { value: "9", label: "Intravenous (IV)" },
//   { value: "10", label: "Intramuscular (IM)" },
//   { value: "11", label: "Subcutaneous (SC or SQ)" },
//   { value: "12", label: "Intradermal (ID)" },
//   { value: "13", label: "Intrathecal" },
//   { value: "14", label: "Intranasal" },
//   { value: "15", label: "Intraocular" },
// ];
export const list3 = [
  { value: "1", label: "Oral" },
  { value: "2", label: "Parenteral" },
  { value: "3", label: "Topical" },
  { value: "4", label: "Mouth & Throat Topical" },
  { value: "5", label: "Nasal" },
  { value: "6", label: "Ophthalmic" },
  { value: "7", label: "Otic" },
  { value: "8", label: "Inhalation" },
  { value: "9", label: "Intra-peritoneal" },
  { value: "10", label: "Rectal" },
  { value: "11", label: "Vaginal" },
  { value: "12", label: "Transdermal" },
  { value: "13", label: "Buccal" },
  { value: "14", label: "Sublingual" },
  { value: "15", label: "Intrathecal" },
  { value: "15", label: "Implantation" },
];

export const list4 = [
  { value: "1", label: "Technology " },
  { value: "2", label: "Issue" },
  { value: "3", label: "other error" },
];
export const list5 = [
  { value: "1", label: "Complexity" },
  { value: "2", label: "Issue" },
  { value: "3", label: "other error" },
];
